import axios from 'axios'

const defaultServiceList = [
  {
    id: 0,
    user_id: 0,
    service_type_id: 6,
    name: '公共演示派盘',
    created_at: 1591200104,
    expired_at: 1906767878,
    subdomain: 'demo',
    os: 'windows',
    resource_id: 0,
    started: 3,
    started_at: -62135596800,
    user_data: { dongle: true, syncthing: true, webdav: true },
    order_id: 0
  }
]

axios.defaults.timeout = 8000

export async function getServiceList (userId, jwt) {
  if (!userId || userId <= 0 || !jwt) return defaultServiceList
  const url = `/huluer-api-go/user/${userId}/services/list`
  try {
    const response = await axios.get(url, {
      headers: { 'huluer-access-token': jwt }
    })
    if (!response.data.length) {
      return defaultServiceList
    }
    return response.data
  } catch (error) {
    console.log(error)
  }
  return defaultServiceList
}

export async function pauseService (userId, jwt, serviceId) {
  if (!userId || userId <= 0 || !jwt || !serviceId || serviceId <= 0) return false
  const url = `/huluer-api-go/user/${userId}/service/${serviceId}/pause`
  try {
    await axios.post(url, {}, {
      headers: { 'huluer-access-token': jwt }
    })
    return true
  } catch (error) {
    console.log(error)
  }
  return false
}

export async function resumeService (userId, jwt, serviceId) {
  if (!userId || userId <= 0 || !jwt || !serviceId || serviceId <= 0) return false
  const url = `/huluer-api-go/user/${userId}/service/${serviceId}/resume`
  try {
    await axios.post(url, {}, {
      headers: { 'huluer-access-token': jwt }
    })
    return true
  } catch (error) {
    console.log(error)
  }
  return false
}

export async function updateServiceName (userId, jwt, serviceId, serviceName) {
  if (!userId || userId <= 0 || !jwt || !serviceId || serviceId <= 0 || !serviceName) return false
  const url = `/huluer-api-go/user/${userId}/service/${serviceId}/update`
  try {
    await axios.post(url, {
      name: serviceName
    }, {
      headers: { 'huluer-access-token': jwt }
    })
    return true
  } catch (error) {
    console.log(error)
  }
  return false
}

export async function addTrial (userId, jwt) {
  if (!userId || userId <= 0 || !jwt) return false
  const url = `/huluer-api-go/user/${userId}/services/create-trail`
  try {
    await axios.post(url, {}, {
      headers: { 'huluer-access-token': jwt }
    })
    return true
  } catch (error) {
    console.log(error)
  }
  return false
}

export function clickUrl (url) {
  const a1 = document.createElement('a')
  a1.setAttribute('href', url)
  a1.click()
}

export function downloadClient () {
  const downloadUrl = 'https://api.huluer.vip/os-302?mac=https://cdn.huluer.vip/iChainPi.pkg&win=https://cdn.huluer.vip/iChainPi.exe&linux=https://www.huluer.com/ichainpi-linux&ios=https://www.huluer.com/ichainpi-mobile&android=https://www.huluer.com/ichainpi-mobile&default=https://www.huluer.com/ichainpi-linux'
  console.log(downloadUrl)
  clickUrl(downloadUrl)
}

export function startService (userId, jwt, serviceId) {
  return new Promise((resolve, reject) => {
    if (!userId || userId <= 0 || !jwt || !serviceId || serviceId <= 0) resolve(1)
    const launcherUrl = `ichainpilauncher://aaa=aaa;start=1;startAuthCookieName=huluer_access_token;startServiceId=${serviceId};startAuthCookieValue=${jwt};bbb=bbb`
    console.log(launcherUrl)
    clickUrl(launcherUrl)
    const maxCount = 3
    let count = 0
    const timer = setInterval(async () => {
      count++
      console.log(count)
      const list = await getServiceList(userId, jwt)
      if (list.some(item => {
        return item.id === serviceId && item.started !== 0
      })) {
        clearInterval(timer)
        resolve(0)
      } else {
        if (count >= maxCount) {
          clearInterval(timer)
          downloadClient()
          resolve(2)
        }
      }
    }, 1000 * 5)
  })
}

export function renewServiceUrl (item, serviceTime) {
  let userData
  if (item.service_type_id === 2) {
    userData = { webdav: true, syncthing: false, dongle: false }
  } else if (item.service_type_id === 3) {
    userData = { webdav: true, syncthing: false, dongle: true }
  } else if (item.service_type_id === 4) {
    userData = { webdav: true, syncthing: true, dongle: true }
  } else if (item.service_type_id === 6) {
    userData = item.user_data
  }
  console.log(userData)
  console.log(serviceTime)
  const serviceId = item.id
  const productId = 4685
  let variationId
  const hfs = 'yes'
  let webdav = 'no'
  let backup = 'no'
  let dongle = 'no'
  if (userData.webdav) {
    webdav = 'yes'
  }
  if (userData.syncthing) {
    backup = 'yes'
  }
  if (userData.dongle) {
    dongle = 'yes'
  }
  if (userData.webdav && userData.syncthing && userData.dongle && serviceTime === '12m') { // webdav 备份 加密 包年
    variationId = 4964
  } else if (userData.webdav && !userData.syncthing && userData.dongle && serviceTime === '12m') { // webdav 加密 包年
    variationId = 4966
  } else if (userData.webdav && userData.syncthing && !userData.dongle && serviceTime === '1m') { // webdav 备份 包月
    variationId = 4967
  } else if (userData.webdav && userData.syncthing && !userData.dongle && serviceTime === '12m') { // webdav 备份 包年
    variationId = 4968
  } else if (userData.webdav && !userData.syncthing && !userData.dongle && serviceTime === '1m') { // webdav 包月
    variationId = 4969
  } else if (userData.webdav && !userData.syncthing && !userData.dongle && serviceTime === '12m') { // webdav 包年
    variationId = 4970
  } else if (!userData.webdav && userData.syncthing && userData.dongle && serviceTime === '12m') { // 加密 备份 包年
    variationId = 4972
  } else if (!userData.webdav && !userData.syncthing && userData.dongle && serviceTime === '12m') { // 加密 包年
    variationId = 4974
  } else if (!userData.webdav && userData.syncthing && !userData.dongle && serviceTime === '1m') { // 备份 包月
    variationId = 4975
  } else if (!userData.webdav && userData.syncthing && !userData.dongle && serviceTime === '12m') { // 备份 包年
    variationId = 4976
  } else if (!userData.webdav && !userData.syncthing && !userData.dongle && serviceTime === '1m') { // 包月
    variationId = 4977
  } else if (!userData.webdav && !userData.syncthing && !userData.dongle && serviceTime === '12m') { // 包年
    variationId = 4978
  }
  console.log(variationId)
  const url = `https://www.huluer.com/checkout/?add-to-cart=${productId}&variation_id=${variationId}&attribute_pa_hfs=${hfs}&attribute_pa_webdav=${webdav}&attribute_pa_backup=${backup}&attribute_pa_dongle=${dongle}&attribute_pa_service-time=${serviceTime}&service-id=${serviceId}`
  return url
}
